import { type DeepPartial } from '@direct-frontend/stdlib';
import { type PromoactionModel } from './types';

export const isPromoactionShowInPdpApplicable = (promoaction: DeepPartial<PromoactionModel>): boolean =>
    promoaction?.mode?.mode === 'promocode' && promoaction?.meta?.type === 'on_products';

export const getPromoactionShowInPdpYesNoText = (promoaction: DeepPartial<PromoactionModel>): string =>
    promoaction?.showInPdp === 'true' ? 'Да' : 'Нет';
